module.exports = __webpack_public_path__ + "static/media/about-PC.df8ef3ab.png";